import { AuthState } from '@okta/okta-auth-js';

import { FuturesBrokersMassUpdates } from '../../services/backend/FuturesBrokersMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFuturesBrokersMassUpdates: () => FuturesBrokersMassUpdates<AuthState> = () => {
  return useBaseApiClient(FuturesBrokersMassUpdates);
};
